export default "__VITE_ASSET__e72f7f94__"